// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  * {
    /* stylelint-disable-next-line declaration-no-important */
    text-shadow: none !important;
  }
  .uNMk40FEUcf0gC {
    display: none;
  }
}
.gniMlt5U6Q0qGU {
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-200, 16px);
  transition: opacity 0.3s ease;
  transition-delay: 0.2s;
  opacity: 1;
  font-size: 1.4em;
  gap: var(--ds-space-100, 8px);
}
.gniMlt5U6Q0qGU[data-hidden='true'] {
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .gniMlt5U6Q0qGU {
    transition: none;
  }
}
.gniMlt5U6Q0qGU:hover,
.gniMlt5U6Q0qGU:active {
  background-color: transparent;
  color: var(--ds-text-selected, #0c66e4);
}
.t0KGQw7YfYWQ2G {
  display: block;
  padding: var(--ds-space-200, 14px);
  border: 1px solid var(--ds-border-accent-blue, #1d7afc);
  background-color: var(--ds-surface, #ffffff);
  color: var(--ds-text, #172b4d);
  font-size: 1.4em;
  text-align: center;
  text-decoration: none;
}
.jHqxsf1IFNAOqS {
  display: block;
  padding: var(--ds-space-200, 14px);
  border: 1px solid var(--ds-border-accent-blue, #1d7afc);
  background-color: var(--ds-surface, #ffffff);
  color: var(--ds-text, #172b4d);
  text-align: center;
  text-decoration: none;
  border-color: var(--ds-border-accent-blue, #1d7afc);
  background-color: var(--ds-link, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 1.4em;
}
.jHqxsf1IFNAOqS:active {
  border-color: var(--ds-border-accent-blue, #0747a6);
  background-color: var(--ds-link-pressed, #0747a6);
}
.KQqdv8WpXgPD2r {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-200, 14px);
}
.UXFSZr43bhOBuV {
  position: fixed;
  z-index: 90;
  top: var(--ds-space-0, 0);
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  overflow: hidden;
  transition: height 0.3s linear, box-shadow 0.3s linear 0.3s, background-color 0.3s linear 0.3s;
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
.UXFSZr43bhOBuV * {
  box-sizing: border-box;
  font-family: 'Charlie Text', var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
}
.UXFSZr43bhOBuV[data-open='true'] {
  height: 100%;
  transition: height 0.3s linear 0.1s, box-shadow 0.1s linear, background-color 0.1s linear;
}
@media (prefers-reduced-motion: reduce) {
  .UXFSZr43bhOBuV[data-open='true'] {
    transition: none;
  }
}
@media (min-width: 992px) {
  .UXFSZr43bhOBuV {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .UXFSZr43bhOBuV {
    transition: none;
  }
}
.HVqhVLKk8enCUb {
  font-size: 1.4em;
  text-decoration: none;
}
.HVqhVLKk8enCUb:hover,
.HVqhVLKk8enCUb:active {
  color: var(--ds-text-selected, #0c66e4);
}
.hudwJz3OzXsaiB {
  transition: all 0.3s ease;
  transition-delay: 0.2s;
  opacity: 1;
}
.hudwJz3OzXsaiB[data-hidden='true'] {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-left: calc(-141.69px);
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .hudwJz3OzXsaiB {
    transition: none;
  }
}
.Kpuawe3Qceuc2W {
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) auto;
  padding: var(--ds-space-200, 14px);
}
.Kpuawe3Qceuc2W:hover,
.Kpuawe3Qceuc2W:active {
  background-color: transparent;
}
.dggEckjLzoRF23 {
  display: flex;
  z-index: 100;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}
@media (min-width: 992px) {
  .dggEckjLzoRF23 {
    height: 60px;
  }
}
.pxLaBgtAmlvPHx {
  display: flex;
  position: absolute;
  top: 70px;
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  flex-direction: column;
  width: 100%;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 14px) var(--ds-space-200, 14px);
  overflow: auto;
  transition: left 0.4s ease;
  background-color: var(--ds-surface, #ffffff);
  gap: var(--ds-space-200, 14px);
}
.pxLaBgtAmlvPHx h2 {
  margin-bottom: var(--ds-space-0, 0);
}
.pxLaBgtAmlvPHx h2,
.pxLaBgtAmlvPHx h3 {
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
}
.pxLaBgtAmlvPHx p:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
.pxLaBgtAmlvPHx[data-offscreen='left'] {
  left: calc(-100vw);
}
.pxLaBgtAmlvPHx[data-offscreen='right'] {
  left: 100vw;
}
@media (prefers-reduced-motion: reduce) {
  .pxLaBgtAmlvPHx {
    transition: none;
  }
}
.dq8mE6SgdgMOAo {
  transition: opacity 0.6s ease;
  transition-delay: 0.1s;
  opacity: 0;
}
.dq8mE6SgdgMOAo[data-open='true'] {
  opacity: 1;
}
@media (prefers-reduced-motion: reduce) {
  .dq8mE6SgdgMOAo {
    transition: none;
  }
}
.Ws4nmJQO1A9j1a {
  justify-content: space-between;
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-0, 0);
  font-size: 1.4em;
}
.Ws4nmJQO1A9j1a:hover,
.Ws4nmJQO1A9j1a:active {
  border-bottom: 1px solid var(--ds-border, #091e4224);
  background-color: transparent;
  color: var(--ds-text-selected, #0c66e4);
}
.W4fegS8fBVln76 {
  border-top: 1px solid var(--ds-border, #091e4224);
}
.W4fegS8fBVln76 > * {
  display: flex;
  align-items: center;
  min-height: 70px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
`, ""]);
// Exports
export var noPrint = `uNMk40FEUcf0gC`;
export var backButton = `gniMlt5U6Q0qGU`;
export var buttonLink = `t0KGQw7YfYWQ2G`;
export var buttonLinkPrimary = `jHqxsf1IFNAOqS`;
export var buttons = `KQqdv8WpXgPD2r`;
export var header = `UXFSZr43bhOBuV`;
export var tabLink = `HVqhVLKk8enCUb`;
export var logoWrapper = `hudwJz3OzXsaiB`;
export var menuButton = `Kpuawe3Qceuc2W`;
export var navBar = `dggEckjLzoRF23`;
export var page = `pxLaBgtAmlvPHx`;
export var pageContainer = `dq8mE6SgdgMOAo`;
export var tabButton = `Ws4nmJQO1A9j1a`;
export var tabList = `W4fegS8fBVln76`;
export default ___CSS_LOADER_EXPORT___;
